//
//
//
//
//
//
//

export default {
  name: 'App',
	mounted() {
		//document.documentElement.style.fontSize = (window.innerWidth / 10) + 'px';
	}
}



// WEBPACK FOOTER //
// ./src/App.vue